var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMaintenanceClock = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 56,
  height: 56,
  fill: "none",
  viewBox: "132 16 56 56"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M132 32c0-8.837 7.163-16 16-16h24c8.837 0 16 7.163 16 16v24c0 8.837-7.163 16-16 16h-24c-8.837 0-16-7.163-16-16z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#maintenance-clock_svg__a)",
  strokeOpacity: 0.5,
  strokeWidth: 1.6,
  d: "M148 16.8h24c8.395 0 15.2 6.805 15.2 15.2v24c0 8.395-6.805 15.2-15.2 15.2h-24c-8.395 0-15.2-6.805-15.2-15.2V32c0-8.395 6.805-15.2 15.2-15.2Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#090A0C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M171.411 43.305a12.106 12.106 0 1 0-12.108 12.106m9.419 0a2.69 2.69 0 0 1-2.69-2.69 2.69 2.69 0 0 1 2.69-2.69m0 5.38a2.691 2.691 0 0 0 1.902-4.593 2.7 2.7 0 0 0-1.902-.787m0 5.38v2.017m0-7.397v-2.018m4.077 2.354-1.748 1.009m-4.657 2.69-1.749 1.008m0-4.707 1.749 1.009m4.657 2.69 1.749 1.008M159.305 36.58v6.725l2.69 2.69"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "maintenance-clock_svg__a",
  x1: 133.204,
  x2: 153.099,
  y1: 24.68,
  y2: 75.653,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.147,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.877,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0.5
})))));
export default SvgMaintenanceClock;